import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit } from "react-feather";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import TableTop from "../../../Components/UI/TableTop";
import {
  useCPFContributionQuery,
  useInsertCPFContributionMutation,
  useUpdateCPFContributionMutation,
} from "../../../AppQuries/master/CpfContribution/contributions";
import Loader from "../../../feature-module/loader/loader";
import { useTableSearch } from "../../../core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import Breadcrumbs from "core/breadcrumbs";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import ToastNotification from "Components/UI/ToastNotification";
import {
  useCPFTypeQuery,
  useInsertCPFTypeMutation,
  useUpdateCPFTypeMutation,
} from "AppQuries/master/CpfType/cpf-type";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { cpfTypeValidation } from "core/Operations/ValidationSchema/MasterValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import CpfTypeModal from "Components/Modal/master/CpfTypeModal";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const CPFType = () => {
  const userData = useSelector(loggedInUser);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useCPFTypeQuery(
    {
      companyCode: userData?.companyCode,
    },
    {
      enabled: userData?.companyCode,
    }
  );
  const methods = useForm({
    resolver: yupResolver(cpfTypeValidation),
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutate: addItem, isPending: isAdding } = useInsertCPFTypeMutation();
  const { mutate: updateItem, isPending: isUpdating } =
    useUpdateCPFTypeMutation();
  const [selectedItem, setSelectedItem] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  console.log(data);

  const itemData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        id: _id + 1,
        ...d,
      }))
    : [];

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      code: 0,
      shortCode: "",
      description: "",
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    methods.reset({
      companyCode: item.companyCode,
      code: item.code,
      shortCode: item.shortCode,
      description: item.description,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    console.log(payload);
    if (selectedItem) {
      updateItem(payload, {
        onSuccess: (data) => {
          console.log(data);
          if (data?.[0]?.response) {
            toast.success("Updated Successfully.");

            setSelectedItem(null);
            setShow(false);
            GetItems();
          } else {
            toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    } else {
      addItem(payload, {
        onSuccess: (data) => {
          if (data?.[0]?.response) {
            toast.success("Created Successfully.");

            setShow(false);
            GetItems();
          } else {
            toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    }
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
      render: (text, record) => <>{text}</>,
    },

    {
      title: "Short Code",
      dataIndex: "shortCode",
      sorter: (a, b) => a.shortCode.length - b.shortCode.length,
    },

    {
      title: "Description",
      dataIndex: "description",
      sorter: (a, b) => a.description.length - b.description.length,
    },

    {
      title: "Created User",
      dataIndex: "createUser",
      sorter: (a, b) => a.createUser.length - b.createUser.length,
    },

    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.master}
            accessCode={accessCodes.master_cpftypes}
            accessType="haveEdit"
          >
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <Edit className="feather-edit" />
            </Link>
          </Can>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    itemData,
    searchColumns
  );

  if (isLoading || isAdding || isUpdating) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}
          <div className="page-header">
            <div className="page-title">
              <h4>CPF CPF Types</h4>
              <h6>Manage Compnay CPF Type</h6>
              {/* <nav aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-arrow mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="fas fa-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="..">Master</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    CPF Contributions
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Can
                accessModule={accessCodes.master}
                accessCode={accessCodes.master_cpftypes}
                accessType="haveAdd"
              >
                <Link
                  to="#"
                  className="btn btn-added"
                  onClick={handleAddClick}
                  disabled={true}
                >
                  <PlusCircle className="me-2" />
                  Add New CPF Type
                </Link>
              </Can>
              &nbsp;
              <Link to={`${all_routes.master}`} className="btn btn-secondary">
                <i className="fas fa-reply me-2"></i>
                Back
              </Link>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
              />

              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormProvider {...methods}>
        <CpfTypeModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default CPFType;
